import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { hasRole } from "../../../global/hooks/getUserRole";
export const ProxyInfoColumns = (setParams, params) => {
  const modParams = params;
  // ? { ...Object.fromEntries([...params?.entries()]) }
  // : {}; //

  return [
    {
      title: "No",
      dataIndex: "DeviceNo",
      key: "DeviceNo",
      width: 80,
      sorter: (a, b) => a?.DeviceNo - b?.DeviceNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () => {
          return setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceName",
            order: modParams.order === "desc" ? "asc" : "desc",
          }));
        },
      }),
    },
    {
      title: "Description",
      dataIndex: "DeviceDesc",
      key: "DeviceDesc",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    ...(hasRole(1, 2, 3)
      ? [
          {
            title: "OEM",
            dataIndex: "Oem",
            key: "Oem",
            width: 150,
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey={"OemNo"}
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams({
                  ...modParams,
                  sort_by: "OemNo",
                  order: modParams.order === "desc" ? "asc" : "desc",
                }),
            }),
          },
        ]
      : []),
    ...(hasRole(1, 2, 3, 4, 5, 6)
      ? [
          {
            title: "Dealer",
            dataIndex: "Dealer",
            key: "Dealer",
            width: 150,
            render: (text, record) => {
              return record?.Dealer ? text : "Guest";
            },
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey={"DealerNo"}
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams({
                  ...modParams,
                  sort_by: "DealerNo",
                  order: modParams.order === "desc" ? "asc" : "desc",
                }),
            }),
          },
        ]
      : []),
    {
      title: "Customer",
      dataIndex: "Customer",
      key: "Customer",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey={"CustomerNo"}
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "CustomerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Mac"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Mac",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Site Type",
      dataIndex: "SiteType",
      key: "SiteType",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="SiteType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "SiteType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Version",
      dataIndex: "Version",
      key: "Version",
      width: 100,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Version"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Version",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Address"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Address",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Online",
      dataIndex: "Online",
      key: "Online",
      width: 100,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Online"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Online",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      // render: (_, data) => (data.Online === 0 ? "No" : "Yes"),
    },
    {
      title: "",
      fixed: "right",
      width: 1,
      align: "center",
    },
  ];
};
